export const ROOT = '/leads';
export const MODULE = 'LEADS';
